import React, {PropTypes as T} from 'react';
import { findDOMNode } from 'react-dom';
import './style';
import cx from 'classnames';
import { OutsideClickHandler } from 'b3';
import Portal from '../misc/Portal';
import { getPosition, getOffsetsRelevantToAncestor } from '../misc/Coords';

export default class Bubble extends React.Component {

    static propTypes = { 
        onOutsideClick: T.func,
        background: T.string
    };

    static defaultProps = { 
        onOutsideClick: () => {},
        background: '#fff',
        onMouseOver: () => {},
        onMouseOut: () => {},
        orientation: 'top-middle',
        target: null
    };

    constructor(props) {
        super(props);

        this.state = {
        	layoutStyle: {
        		top: 0,
        		left: 0
        	},
            orientation: this.props.orientation
        };
    }
    
    componentWillUpdate(nextProps) {
        // If the bubble was rendered with no target, and now has a target, then we need to update the position and start the animation loop to check for window layout updates
        if(this.props.target == null && nextProps.target != null) {
            requestAnimationFrame(this.updatePosition.bind(this));
        }
    }

    componentDidMount() {
        requestAnimationFrame(this.updatePosition.bind(this));
    }

    /**
    * This sets the initial position of the bubble relative to the targets position on the page
    * - It is built into a requestAnimationFrame loop so that we can respond to layout changes in the page that would have affected the absolute positioning of the bubble relative to it's target
    */
    updatePosition() {

        // Find proper position to place this element
        if (this.props.target && this.refs.bubble) {

            var subjectRect = findDOMNode(this.refs.bubble).getBoundingClientRect();
            var targetRect = findDOMNode(this.props.target).getBoundingClientRect();
            var currentPosition = this.state.layoutStyle;
            var body = findDOMNode(this).closest('.b3-virtual-body') || document.body;
            
            var offsets = getOffsetsRelevantToAncestor(findDOMNode(this.props.target), body);

            var layout = {
                targetTop: offsets.top,
                targetBottom: offsets.top + targetRect.height,
                targetLeft: offsets.left,
                targetRight: offsets.left + targetRect.width,
                targetWidth: targetRect.width,
                targetHeight: targetRect.height,
                subjectWidth: subjectRect.width,
                subjectHeight: subjectRect.height,
            }

            var newPosition = getPosition(this.state.orientation, layout);

            // Only signal a state change if coordinates have changed
            if(currentPosition.top != newPosition.style.top || currentPosition.left != newPosition.style.left) {
                this.setState({
                    layoutStyle: newPosition.style,
                    orientation: newPosition.orientation
                });    
            }

            requestAnimationFrame(this.updatePosition.bind(this)); 
        }

    }

    handleClickOutside(e) {
        this.props.onOutsideClick(e);
    }
    
    getCaretPosition(orientation) {
        var delimiter = orientation.indexOf("-");
        var newOrientation = orientation.slice(0, delimiter);
        return newOrientation.charAt(0).toUpperCase() + newOrientation.slice(1);
    }

	render() {
        var { layoutStyle, orientation } = this.state;
        var { background, onMouseOver, onMouseOut } = this.props;
        var bubbleClasses = cx("b3-bubble", orientation);
        var caretClasses = cx("b3-bubble-caret", orientation);
        var caretPosition = this.getCaretPosition(orientation);

        var caretStyle = {};
        caretStyle[`border${caretPosition}Color`] = background;

        return (
        	<Portal>
	        	<div ref="bubble" className={bubbleClasses} style={layoutStyle} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                    <OutsideClickHandler onOutsideClick={this.handleClickOutside.bind(this)}>
    		        	<div className={caretClasses} style={caretStyle}></div>

    		        	<div className="b3-bubble-inner" style={{background}}>
    		        		{this.props.children}
    		        	</div>
                    </OutsideClickHandler>
	        	</div>
        	</Portal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/bubble/Bubble.js